import React, { Suspense, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import MarkdownMessage from '@gluedigital/markdown-message'
import ClientSupport from 'src/components/Header/ClientSupport/ClientSupport'
import Loading from 'src/components/Loading/Loading'
import { useConfirmToken, useUserActions } from 'src/hooks/api'

import './Recover.sass'
import { checkPassword } from 'src/util/checkPass'

const Recover = () => {
  const [pw1, setPw1] = useState('')
  const [pw2, setPw2] = useState('')
  const [status, setStatus] = useState('')
  const userActions = useUserActions()
  const { user, token } = useParams<{ user: string, token: string }>()
  const { isValid } = useConfirmToken(user, token)

  const handleSubmit = async (e) => {
    e.preventDefault()
    e.target.send.disabled = true
    if (status === 'loading') return
    if (pw1 !== pw2) {
      setStatus('error-different')
      e.target.send.disabled = false
      return
    }
    if (!checkPassword(pw1)) {
      setStatus('incorrect-password')
      e.target.send.disabled = false
      return
    }
    setStatus('loading')
    try {
      await userActions.recoveryComplete(user, token, pw1)
      setStatus('success')
    } catch (error) {
      if (error.payload.error === "New password can't be an old one") {
        setStatus('password-repeat')
      } else if (error.payload.error === "The password is too common") {
        setStatus('password-common')
      } else {
        setStatus('error')
      }
      e.target.send.disabled = false
      console.warn(error)
    }
  }
  const recoverForm =
    <form className={status} onSubmit={handleSubmit}>
      <h1><FormattedMessage id="recover.step2.title" /></h1>
      {status === 'success' &&
        <>
          <p className="success-text"><FormattedMessage id="recover.step2.success" /></p>
          <Link className="button filled" to="/login">
            <FormattedMessage id="accept" />
          </Link>
        </>
      }
      {status !== 'success' &&
        <>
          <p><MarkdownMessage id="recover.step2.text" /></p>
          <label>
            <span className="icon icon-lock" />
            <input
              required
              autoFocus
              placeholder="Nueva contraseña..."
              type="password"
              name="password"
              value={pw1}
              onChange={e => setPw1(e.target.value)}
            />
          </label>
          <label>
            <span className="icon icon-lock" />
            <input
              required
              autoFocus
              placeholder="Repetir contraseña..."
              type="password"
              name="password"
              value={pw2}
              onChange={e => setPw2(e.target.value)}
            />
          </label>
          {
            status &&
            <p className="error-text">
              <FormattedMessage id={`recover.step2.${status}`} />
            </p>
          }
          <button name="send" className="filled" disabled={status === 'success'}>
            <FormattedMessage id="recover.send" />
          </button>
        </>
      }
    </form>
  let content = recoverForm
  if (status === 'loading') content = <Loading />
  if (!isValid) {
    content =
      <form>
        <h3><FormattedMessage id="recover.step2.invalid-token" /></h3>
        <Link to="/recover" className="button filled">
          <FormattedMessage id="back" />
        </Link>
      </form>
  }

  return (
    <div id="recover" className="page">
      <header id="recover-header">
        <ClientSupport />
      </header>
      <div className="split">
        <div className="item item-left" />
        <div className="item item-right">
          <div className="wrapper">
            <Link to="/" className="logo" />
            {content}
          </div>
        </div>
      </div>
    </div>
  )
}

const RecoverWrapper = () =>
  <Suspense fallback={<Loading />}>
    <Recover />
  </Suspense>

export default RecoverWrapper
